
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/serato",
      function () {
        return require("private-next-pages/serato.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/serato"])
      });
    }
  